import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=341babe9&"
import script from "./EmailSettings.vue?vue&type=script&lang=js&"
export * from "./EmailSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettings.vue?vue&type=style&index=0&id=341babe9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports